import type { SelectOption } from '@/design-system';

export const SHAREHOLDER_TYPE_OPTIONS: readonly SelectOption[] = [
  { label: 'Individual', value: 'Individual' },
  { label: 'Entity', value: 'Entity' },
];

export const SHAREHOLDER_FIELDS = [
  {
    name: 'fullName',
    label: 'Full Name',
    placeholder: 'Shareholder Name',
  },
  {
    name: 'email',
    label: 'Email address',
    placeholder: 'Shareholder Email',
  },
  {
    name: 'numberOfShares',
    label: 'Number of Shares',
    placeholder: '# Shares',
  },
] as const;
